import { createSlice } from "@reduxjs/toolkit";
import {
  addEmail,
  getEmailById,
  getAllEmailsByInstitute,
} from "../actions/email";
import {
  addReport,
  getReportById,
  getAllReportsByInstitute,
  getReportByModuleAndModuleId,
  addTagReport,
  createReportBatch,
  getReportBatchById,
  getReportBatchesByInstitution,
  regenerateReportBatch,
  removeReportBatch,
  removeReportFromBatch,
  removeReport
} from "../actions/report";
import { logoutUser } from "../actions/account";

const initialState = {
  error: false,
  isLoadingAddReport: false,
  isLoadingAllReportsForInstitute: false,
  postedData: {},
  isLoadingGetReportById: false,
  reportDetails: {},
  reportList: [],
  selectedTemplate: "",
  reportFile: "",
  reportTitle: "",
  isLoadingGetReportByModuleAndModuleId: false,
  reportsForModule: [],
  isLoadingCreateReportBatch: false,
  isLoadingGetReportBatchById: false,
  isLoadingGetReportBatchesByInstitution: false,
  isLoadingRegenerateReportBatch: false,
  isLoadingRemoveReportBatch: false,
  isLoadingRemoveReportFromBatch: false,
  isLoadingRemoveReport: false,
  reportBatchDetails: {},
  reportBatches: []
};

const reportSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {
    "account/logoutUser": (state) => initialState,
    setSelectedTemplate(state, action) {
      state.selectedTemplate = action.payload;
    },
    setReportFile(state, action) {
      state.reportFile = action.payload;
    },
    setReportTitle(state, action) {
      state.reportTitle = action.payload;
    },
  },
  extraReducers: {
    [addReport.pending]: (state, action) => {
      state.isLoadingAddReport = true;
      state.error = false;
    },
    [addReport.fulfilled]: (state, action) => {
      state.isLoadingAddReport = false;
      state.postedData = action?.payload?.data;
      state.reportDetails = action?.payload?.data;
      state.error = false;
    },
    [addReport.rejected]: (state, action) => {
      state.isLoadingAddReport = false;
      state.error = true;
    },
    [addTagReport.pending]: (state, action) => {
      state.isLoadingAddReport = true;
      state.error = false;
    },
    [addTagReport.fulfilled]: (state, action) => {
      state.isLoadingAddReport = false;
      state.postedData = action?.payload?.data;
      state.reportDetails = action?.payload?.data;
      state.error = false;
    },
    [addTagReport.rejected]: (state, action) => {
      state.isLoadingAddReport = false;
      state.error = true;
    },
    [getReportById.pending]: (state, action) => {
      state.isLoadingGetReportById = true;
      state.error = false;
    },
    [getReportById.fulfilled]: (state, action) => {
      state.isLoadingGetReportById = false;
      state.reportDetails = action?.payload?.data?.report;
      state.error = false;
    },
    [getReportById.rejected]: (state, action) => {
      state.isLoadingGetReportById = false;
      state.error = true;
    },//getReportByModuleAndModuleId
    [getReportByModuleAndModuleId.pending]: (state, action) => {
      state.isLoadingGetReportByModuleAndModuleId = true;
      state.error = false;
    },
    [getReportByModuleAndModuleId.fulfilled]: (state, action) => {
      state.isLoadingGetReportByModuleAndModuleId = false;
      state.reportsForModule = action?.payload?.data;
      state.error = false;
    },
    [getReportByModuleAndModuleId.rejected]: (state, action) => {
      state.isLoadingGetReportByModuleAndModuleId = false;
      state.error = true;
    },
    [getAllReportsByInstitute.pending]: (state, action) => {
      state.isLoadingAllReportsForInstitute = true;
      state.error = false;
    },
    [getAllReportsByInstitute.fulfilled]: (state, action) => {
      state.isLoadingAllReportsForInstitute = false;
      state.reportList = action?.payload?.data?.reports;
      state.error = false;
    },
    [getAllReportsByInstitute.rejected]: (state, action) => {
      state.isLoadingAllReportsForInstitute = false;
      state.error = true;
    },
    [createReportBatch.pending]: (state) => {
      state.isLoadingCreateReportBatch = true;
      state.error = false;
    },
    [createReportBatch.fulfilled]: (state, action) => {
      state.isLoadingCreateReportBatch = false;
      state.reportBatchDetails = action?.payload?.data;
      state.error = false;
    },
    [createReportBatch.rejected]: (state) => {
      state.isLoadingCreateReportBatch = false;
      state.error = true;
    },
    [getReportBatchById.pending]: (state) => {
      state.isLoadingGetReportBatchById = true;
      state.error = false;
    },
    [getReportBatchById.fulfilled]: (state, action) => {
      state.isLoadingGetReportBatchById = false;
      state.reportBatchDetails = action?.payload?.data;
      state.error = false;
    },
    [getReportBatchById.rejected]: (state) => {
      state.isLoadingGetReportBatchById = false;
      state.error = true;
    },
    [getReportBatchesByInstitution.pending]: (state) => {
      state.isLoadingGetReportBatchesByInstitution = true;
      state.error = false;
    },
    [getReportBatchesByInstitution.fulfilled]: (state, action) => {
      state.isLoadingGetReportBatchesByInstitution = false;
      state.reportBatches = action?.payload?.data?.batches || [];
      state.error = false;
    },
    [getReportBatchesByInstitution.rejected]: (state) => {
      state.isLoadingGetReportBatchesByInstitution = false;
      state.error = true;
    },
    [regenerateReportBatch.pending]: (state) => {
      state.isLoadingRegenerateReportBatch = true;
      state.error = false;
    },
    [regenerateReportBatch.fulfilled]: (state, action) => {
      state.isLoadingRegenerateReportBatch = false;
      state.reportBatchDetails = action?.payload?.data;
      state.error = false;
    },
    [regenerateReportBatch.rejected]: (state) => {
      state.isLoadingRegenerateReportBatch = false;
      state.error = true;
    },
    [removeReportBatch.pending]: (state) => {
      state.isLoadingRemoveReportBatch = true;
      state.error = false;
    },
    [removeReportBatch.fulfilled]: (state) => {
      state.isLoadingRemoveReportBatch = false;
      state.error = false;
    },
    [removeReportBatch.rejected]: (state) => {
      state.isLoadingRemoveReportBatch = false;
      state.error = true;
    },
    [removeReportFromBatch.pending]: (state) => {
      state.isLoadingRemoveReportFromBatch = true;
      state.error = false;
    },
    [removeReportFromBatch.fulfilled]: (state) => {
      state.isLoadingRemoveReportFromBatch = false;
      state.error = false;
    },
    [removeReportFromBatch.rejected]: (state) => {
      state.isLoadingRemoveReportFromBatch = false;
      state.error = true;
    },
    [removeReport.pending]: (state) => {
      state.isLoadingRemoveReport = true;
      state.error = false;
    },
    [removeReport.fulfilled]: (state) => {
      state.isLoadingRemoveReport = false;
      state.error = false;
    },
    [removeReport.rejected]: (state) => {
      state.isLoadingRemoveReport = false;
      state.error = true;
    },
    [logoutUser.fulfilled]: (state) => {
      return initialState;
    },
    [logoutUser.rejected]: (state) => {
      return initialState;
    },
  },
});

export const getError = (state) => state.reports.error;
export const getIsLoadingAddReport = (state) =>
  state.reports.isLoadingAddReport;
export const getPostedData = (state) => state.reports.postedData;
export const getIsLoadingGetReportById = (state) =>
  state.reports.isLoadingGetReportById;
export const getIsLoadingAllReportsForInstitute = (state) =>
  state.reports.isLoadingAllReportsForInstitute;
export const getReportDetails = (state) => state.reports.reportDetails;
export const getReportsList = (state) => state.reports.reportList;
export const getSelectedTemplate = (state) => state.reports.selectedTemplate;
export const getReportFile = (state) => state.reports.reportFile;
export const getReportTitle = (state) => state.reports.reportTitle;

export const getIsLoadingReportByModuleAndModuleId = (state) => state.reports.isLoadingGetReportByModuleAndModuleId;
export const getReportsForModule = (state) => state.reports.reportsForModule;
export const getIsLoadingCreateReportBatch = (state) => state.reports.isLoadingCreateReportBatch;
export const getIsLoadingGetReportBatchById = (state) => state.reports.isLoadingGetReportBatchById;
export const getIsLoadingGetReportBatchesByInstitution = (state) => state.reports.isLoadingGetReportBatchesByInstitution;
export const getIsLoadingRegenerateReportBatch = (state) => state.reports.isLoadingRegenerateReportBatch;
export const getIsLoadingRemoveReportBatch = (state) => state.reports.isLoadingRemoveReportBatch;
export const getIsLoadingRemoveReportFromBatch = (state) => state.reports.isLoadingRemoveReportFromBatch;
export const getIsLoadingRemoveReport = (state) => state.reports.isLoadingRemoveReport;
export const getReportBatchDetails = (state) => state.reports.reportBatchDetails;
export const getReportBatches = (state) => state.reports.reportBatches;

export const {
  setSelectedTemplate,
  setReportFile,
  setReportTitle
} = reportSlice.actions;

export default reportSlice;
